import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0d87daf5&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0d87daf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87daf5",
  null
  
)

export default component.exports